'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _utils = require('../utils');

var _fullscreen = require('@wix/photography-client-lib/dist/src/versioning/features/fullscreen');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BottomLink = function (_React$Component) {
  (0, _inherits3.default)(BottomLink, _React$Component);

  function BottomLink() {
    (0, _classCallCheck3.default)(this, BottomLink);
    return (0, _possibleConstructorReturn3.default)(this, (BottomLink.__proto__ || (0, _getPrototypeOf2.default)(BottomLink)).apply(this, arguments));
  }

  (0, _createClass3.default)(BottomLink, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var curItem = this.props.current.item;

      var bottomLink = curItem.hasLink && (!_utils.utils.isMobile() || _fullscreen.fullscreenVersionManager.useFullscreenNewMobileLayout()) ? curItem.linkType === 'web' ? _react2.default.createElement(
        'a',
        {
          className: 'fullscreen-bottom-link pro-fullscreen-link',
          href: curItem.linkUrl,
          target: curItem.linkOpenType,
          tabIndex: _utils.utils.getTabIndex('fullscreenLink'),
          'aria-label': curItem.linkText
        },
        curItem.linkText ? curItem.linkText : curItem.linkUrl
      ) : _react2.default.createElement(
        'a',
        {
          className: 'fullscreen-bottom-link pro-fullscreen-link',
          onClick: function onClick() {
            return _this2.props.actions.navigate(curItem);
          },
          tabIndex: _utils.utils.getTabIndex('fullscreenLink'),
          'aria-label': curItem.linkText
        },
        curItem.linkText ? curItem.linkText : curItem.linkUrl
      ) : false;

      var bottomLinkContainer = (!this.props.current.hasInfo || _utils.utils.isMobile()) && curItem.hasLink ? _react2.default.createElement(
        'div',
        { className: 'pro-fullscreen-bottom-link' },
        bottomLink
      ) : false;

      return bottomLinkContainer;
    }
  }]);
  return BottomLink;
}(_react2.default.Component);

exports.default = BottomLink;